<template>
  <div id="card-map" class="card-container">
   <div class="cross" @click="$emit('unselect', idMarker)">
      <img src="../../images/Croix fermer.svg" alt="fermer" />
    </div>
    <div class="card-body">
      <img
        class="card-image w-100 mb-0"
        :src="this.formatSource()"
        :alt="this.lodging.name"
      />
      <div class="d-flex flex-column overflow-auto card-text-body">
        <h3 class="card-title text-uppercase raleway-bold-p14 mb-1 pt-1">{{ this.lodging.name }}</h3>
        <h5 class="card-subtitle merriweather-italic-14 text-left mb-1 pt-2">{{ this.lodging.address }}</h5>
        <p class="card-description pt-1">
          {{ this.lodging.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryCardmap",
  props: ["lodging", "idMarker"],
  methods: {
    formatSource() {
      return this.lodging.photo_key || "https://media.gettyimages.com/photos/bedroom-in-new-luxury-home-picture-id1194686012?k=6&m=1194686012&s=612x612&w=0&h=IX6Bjhwa5M5NtCtlKll-FFi_hn5lxrPwiUImH3fsZZ0=";
    },
  },
  mounted() {
    console.log("CardMap mounted with lodging:", this.lodging);   
  }
};
</script>

<style scoped>
.card-container {
  padding: 0px !important;
  width: 40% !important;
  height: 450px !important;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cross {
  position: absolute;
  top: 3px;
  right: 8px;
  cursor: pointer;
}

.card-body {
  padding-top: 25px !important;
  padding: 10px 10px 0px 10px;
  text-align: center;
  flex: 1;
  overflow: hidden;
}

.card-image {
  width: 147px;
  height: 147px;
  object-fit: cover;
  margin-bottom: 10px;
}

.card-title {
  display: flex;
  align-items: center !important;
  margin-bottom: 3px !important;
  color: #333;
  text-align: left;
  line-height: 100%;
  letter-spacing: 0% !important;
  vertical-align: middle;
}

.card-description {
  margin-bottom: 0px !important;
  font-size: 12px;
  line-height: 1.5;
  color: #666;
  text-align: left;
  padding-right: 5px;
}

.card-description::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 2px;
}

.card-text-body {
  scrollbar-width: thin; /* For Firefox */
}
.card-text-body::-webkit-scrollbar {
  width: 4px; /* For Webkit-based browsers */
}
.card-subtitle {
  @media screen and (max-width: 768px) {
    padding-top: 5px;
  }
}
</style>
